module.exports = __webpack_public_path__ + "3328e1660d877378c782d9274b0d7908.svg";